"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _ChoicePicker = _interopRequireWildcard(require("web/shared/telemetry/components/ChoicePicker"));
var _HistogramPlot = _interopRequireDefault(require("web/shared/telemetry/charts/HistogramPlot"));
var _HistogramData = require("web/shared/telemetry/charts/Histogram.data.js");
var _durations = require("web/shared/telemetry/format/durations.js");
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The distribution, as a panel of its own.
*
* It owns how finely it is cut, because that control belongs to this chart and
* to nothing else on the page: a reader flicks between a coarse cut and a
* fine one while watching this one shape, and nothing outside it changes.
*/
const BUCKET_OPTIONS = (0, _ChoicePicker.numberChoices)(_HistogramData.BUCKET_CHOICES, count => String(count));
function Histogram(_ref) {
  let records = _ref.records;
  const _useState = (0, _react.useState)(_HistogramData.DEFAULT_BUCKET_COUNT),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    bucketCount = _useState2[0],
    setBucketCount = _useState2[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.panel)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.panelHeader)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.subHeading)), {}, {
        children: "Distribution"
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.controls)), {}, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChoicePicker.default, {
          options: BUCKET_OPTIONS,
          selected: bucketCount,
          onPick: setBucketCount
        })
      }))]
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.panelDescription)), {}, {
      children: "Two humps usually mean two populations under one name \u2014 a cache hit and a miss, or two callers doing different amounts of work."
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_HistogramPlot.default, {
      durationsMs: (0, _durations.completedDurationsMs)(records),
      bucketCount: bucketCount
    })]
  }));
}
var _default = exports.default = Histogram;